import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
import { Dialog, DialogContent } from './ui/dialog';
import { Play, X } from 'lucide-react';

const galleryItems = [
  { type: 'image', src: '/gallery/photo1.webp', alt: 'Aron Best Legacy Seminar 2014 - Portrait' },
  { type: 'image', src: '/gallery/photo2.webp', alt: 'Aron Best Legacy Seminar 2014 - Presentation' },
  { type: 'video', src: '/gallery/video1.mp4', poster: '/gallery/photo1.webp' },
  { type: 'video', src: '/gallery/video2.mp4', poster: '/gallery/photo2.webp' }
];

const GallerySection = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const [selectedItem, setSelectedItem] = useState(null);

  return (
    <section id="gallery" className="py-24 bg-gradient-to-br from-cream-50 via-white to-blue-50" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif font-bold text-navy-900 mb-4">{t.gallery.title}</h2>
          <p className="text-xl text-gold-600 font-medium">{t.gallery.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {galleryItems.map((item, index) => (
            <div
              key={index}
              data-testid={`gallery-item-${index}`}
              onClick={() => setSelectedItem(item)}
              className="group relative aspect-[4/5] bg-navy-900 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              {item.type === 'image' ? (
                <img
                  src={item.src}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              ) : (
                <>
                  <video
                    src={item.src}
                    poster={item.poster}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    preload="metadata"
                    muted
                  />
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                    <div className="p-5 bg-gold-600 rounded-full shadow-2xl group-hover:bg-gold-500 group-hover:scale-110 transition-all">
                      <Play className="text-white fill-white" size={32} />
                    </div>
                  </div>
                </>
              )}
              <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/70 to-transparent pointer-events-none" />
            </div>
          ))}
        </div>
      </div>

      <Dialog open={!!selectedItem} onOpenChange={() => setSelectedItem(null)}>
        <DialogContent className="max-w-5xl w-[95vw] p-0 bg-black border-none overflow-hidden">
          <button
            onClick={() => setSelectedItem(null)}
            className="absolute top-4 right-4 z-50 p-2 bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors"
            aria-label="Close"
          >
            <X size={24} />
          </button>
          {selectedItem?.type === 'image' ? (
            <img
              src={selectedItem.src}
              alt={selectedItem.alt}
              className="w-full h-auto max-h-[85vh] object-contain"
            />
          ) : selectedItem?.type === 'video' ? (
            <video
              src={selectedItem.src}
              controls
              autoPlay
              className="w-full h-auto max-h-[85vh]"
            />
          ) : null}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default GallerySection;
